import { ITheme } from './theme'

export const QR_THEME: ITheme = {
  pisJourneyListBg: 'white',
  pisContainerBg: 'white',
  pisHeaderHeight: '5.8rem',
  pisBorderC: '#e0e0e0',
  pisEmptyListC: '#1e234f',
}
